/* eslint-disable @reatom/unit-naming-rule */
import { useAction } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled, { css } from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { useTranslation } from '@root/shared/localization'
import { InfoMessageDt } from '@root/shared/ui-kit/info-message/info-message-dt'

import { reatomUserProfileDeployedTokensTable } from '../atoms/reatom-user-profile-deployed-tokens-table'

import type { DelugeId } from '@root/entities/user-short'

type Props = {
  delugeId: DelugeId
}
export const UserProfileDeployedTokensTable = ({ delugeId }: Props) => {
  const { t } = useTranslation()
  const model = useMemo(() => {
    return reatomUserProfileDeployedTokensTable({
      delugeId,
    })
  }, [delugeId])
  const load = useAction(model.load)

  return (
    <Root>
      <AppDataTable
        model={model}
        rowHeight={40}
        css={css`
          height: 100%;
        `}
        renderEmptyMessage={() => (
          <InfoMessageDt
            withBackground
            intent="empty"
            title={t('dev-tokens.no-tokens.title')}
            description={t('dev-tokens.no-tokens.description')}
            onRetry={load}
            retryText={t('common.refresh')}
          />
        )}
        renderError={() => (
          <InfoMessageDt
            withBackground
            intent="error"
            onRetry={load}
            retryText={t('common.refresh')}
          />
        )}
      />
    </Root>
  )
}

const Root = styled.div`
  height: 100%;
  max-height: var(--viewport-height);
`
